require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./up-all-night-to-this-song.json") })
        }
      }, "path---up-all-night-to-this-song");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---up-all-night-to-this-song!./.cache/json/up-all-night-to-this-song.json
// module id = 580
// module chunks = 231608221292675